import React from 'react';

export const MoonIcon = ({ className }) => (
    <svg viewBox="0 0 24 24" className={className}><path d="m 7.0406135,0.34024732 c 0,0 -2.4739317,19.09781068 16.4089625,16.74987268 C 23.295504,21.989594 8.3400034,28.363412 2.23944,16.059486 0.71424615,12.983397 -0.14207624,5.3599537 7.0406135,0.34024732"></path></svg>
);
